import { render, staticRenderFns } from "./SidebarMobile.vue?vue&type=template&id=f3072eb2&"
import script from "./SidebarMobile.vue?vue&type=script&lang=ts&"
export * from "./SidebarMobile.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarMobile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports